var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "op-select" },
    [
      !_vm.isReadonly
        ? _c(
            "el-select",
            {
              attrs: {
                "collapse-tags": "",
                placeholder: _vm.placeholder,
                size: _vm.size,
                multiple: _vm.multiple,
                disabled: _vm.disabled,
                clearable: "",
                filterable: "",
                remote: _vm.remote,
              },
              on: {
                "remote-method": _vm.remoteMethod,
                change: _vm.change,
                clear: _vm.clear,
              },
              model: {
                value: _vm.insValue,
                callback: function ($$v) {
                  _vm.insValue = $$v
                },
                expression: "insValue",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: {
                  label: item.label,
                  disabled: _vm.optionDisableds.some(function (p) {
                    return p === item.label
                  }),
                  value: item.value,
                },
              })
            }),
            1
          )
        : _c("span", { staticClass: "op-select-txt" }, [
            _vm._v(_vm._s(_vm.selectedName || "-")),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }